import { privateApi } from 'services';
import { Phase } from './types';

const fetchPhase = (phaseId: string): Promise<Phase> => privateApi.get<Phase>(`brands-phases/${phaseId}`);

const deletePhase = (phaseId: string): Promise<void> => privateApi.delete<void>(`brands-phases/${phaseId}`);

export const PhaseGateway = {
    fetchPhase,
    deletePhase,
};
